exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".back-button__arrow-2xrQUf{cursor:pointer;content:url(https://statisc2test.kudobuzz.com/icons/icon-back.svg);display:inline-block;margin:auto 15px 0 0;width:14px;height:20px}", ""]);
